var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.menu_role_group_id=='5be25ecb-1a4a-43fb-9bd2-bca6b23d4d10')?_c('div',[_c('CustomerDashboard')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }